<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="showModal"
        class="fixed top-0 left-0 md:p-15 w-full h-full bg-backdrop flex justify-center items-center z-100"
        @click.self="close"
      >
        <div
          class="relative mx-0 pb-50 pt-30 px-30 md:px-48 max-w-650 w-full rounded-4"
          :class="isDarkMode ? 'bg-sidebar' : 'bg-primary'"
        >
          <div class="flex justify-end">
            <ButtonModule
              prefix="icon-close"
              :has-hover="true"
              class="absolute top-20 right-20 text-18 text-app-color cursor-pointer"
              @click="close"
            />
          </div>
          <div>
            <div class="text-app-color text-center">
              <PopupImage class="w-full mb-30 cursor-pointer" @click="upgradeToPro" />
              <div class="flex justify-center">
                <p class="text-20 md:text-22 font-black">
                  The Week Planner
                </p>
                <div class="flex items-start cursor-pointer" @click="upgradeToPro">
                  <span
                    class="text-11 font-medium bg-link-color opacity-80 hover:opacity-100
                           ml-8 px-7 py-1 rounded-4 uppercase text-white anim-opacity"
                  >pro</span>
                </div>
              </div>
              <p class="text-17 mt-20 mb-25 md:text-justify">
                Use our redesigned week planner to stay on top of things. Plan ahead and get work done at the right time.
                <a :href="url" class="underline cursor-pointer" target="_blank">Upgrade to PRO</a>
                to get full access.
              </p>
            </div>
            <div class="flex justify-center items-center">
              <ButtonModule
                text="Upgrade to PRO"
                class="text-17 w-full font-bold max-w-320 rounded-4 justify-center py-16 text-white bg-link-color hover:bg-transparent hover:text-link-color border-2 border-link-color"
                @click="upgradeToPro"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import PopupImage from '@/components/week-planner/PopupImage'

export default defineComponent({
  name: 'WelcomeModal',

  components: { ButtonModule, PopupImage },

  setup () {
    const { state, getters } = useStore()

    const showModal = ref(false)

    const user = computed(() => state.profile.user)
    const isDarkMode = computed(() => getters.isDarkMode)
    const url = computed(() => `https://helloivy.co/upgrade?userId=${user.value.id}`)

    function close () {
      showModal.value = false
    }

    function open () {
      showModal.value = true
    }

    function upgradeToPro () {
      if (user.value) {
        window.open(`https://helloivy.co/upgrade?userId=${user.value.id}`, '_blank')
      }
    }

    return {
      // data
      showModal,
      // computed
      url,
      isDarkMode,
      // function
      upgradeToPro,
      close,
      open
    }
  }
})
</script>
